export default {
    "ev_session.session_id": "Session id",
    "ev_session.fee": "Fee (HK$)",
    "ev_session.cha_id": "Charger id",
    "ev_session.con_db_id": "Connector id",
    "ev_session.meter_start": "Meter start reading (wh)",
    "ev_session.meter_stop": "Meter stop reading (wh)",
    "ev_session.stop_reason": "Stop reason",
    "ev_session.press_start_time": "Press start time",
    "ev_session.start_time": "Start time",
    "ev_session.press_end_time": "Press end time",
    "ev_session.end_time": "End time",
    "ev_session.billing_type": "Billing type",
    "ev_session.status": "Status",
    "ev_session.soc": "SoC",
    "ev_session.cal_fee_at": "Calculated fee at",
    "ev_session.waiverReason": "Waiver reason",

    "transaction.category": "Category",
    "transaction.status": "Status",
    "transaction.payment_vendor": "Payment vendor",
    "transaction.payment_method": "Payment method",
    "transaction.total_cost": "Total cost (HK$)",
    "transaction.total_discount": "Total discount (HK$)",
    "transaction.final_cost": "Final cost (HK$)",
    "transaction.begin_date": "Begin date",
    "transaction.complete_date": "Complete date",
    "transaction.amount": "Amount (HK$)",
    "transaction.platform": "Platform",
    "transaction.info": "Transaction information",
    "transaction.topup": "Topup information",
    "transaction.ev_session": "Charging Session information",

    "transaction_line.trx_line_id": "Line Id",
    "transaction_line.category": "Category",
    "transaction_line.cost": "Cost",
    "transaction_line.reference": "Reference",

    "report.report_id": "Id",
    "report.report_name": "Report name",
    "report.cutoff_date": "Cutoff date",
    "report.created_at": "Created At",
    "report.updated_at": "Updated At",
    "report.deleted_at": "Deleted At",
    "report.info": "Report Info",
    "report.setting": "Setting",
    "report_time": "Report time",
    "report_manual_input": "Specific expenditure amount",
    "report_form_edit": "Edit Report",
    "report_form_create": "Create Report",


    "report_generated.generated_date": "Generated date",
    "report_generated.status": "Status",

    "mobile_ads.position": "Position",
    "mobile_ads.external_link": "External link",
    "mobile_ads.period": "Advertising period",
    "mobile_ads.start_time": "Start time",
    "mobile_ads.end_time": "End time",

    "ph.name_en": "Holiday name",
    "ph.day": "Day",
    "ph.ph_id": "Id",

    "promotion.promotion_id": "Id",
    "promotion.promotion_name_en": "Promotion name (English)",
    "promotion.promotion_name_tc": "Promotion name (Chinese)",
    "promotion.promotion_description_en": "Promotion description (English)",
    "promotion.promotion_description_tc": "Promotion description (Chinese)",
    "promotion.start_date": "Start Date",
    "promotion.end_date": "End date",
    "promotion.quota": "Quota",
    "promotion.method": "Method",
    "promotion.date_period": "Date Period",
    "promotion.coupon_valid_period_day": "Coupon valid period (Days)",
    "promotion.setting": "Rules",
    "promotion.new_setting": "New rule",
    "promotion.topup_amount": "Topup amount",
    "promotion.coupon_amount_setting": "Coupon Setting",
    "promotion.coupon_amount": "Coupon amount",
    "promotion.coupon_count": "Count",
}